import styled from "styled-components"
import {IoSettingsSharp} from "react-icons/io5"
// import KayitliYuklerimInput from "../../inputs/KayitliYuklerimInput"
import LoadSection from "../../mainSections/LoadSection"
import OdemeSection from "../../mainSections/OdemeSection"
import AracSection from "../../mainSections/AracSection"
import MenuSection from "../../mainSections/MenuSection"
import { useState } from "react"
import RoutePlanlamaSection from "../../mainSections/RoutePlanlamaSection"
import YuklemeSection from "../../mainSections/YuklemeSection"
import BosaltmaSection from "../../mainSections/BosaltmaSection"
import { useSelector } from "react-redux"
import Button from "../../../shared/Button"
import { useDispatch } from "react-redux"
import { clearDataPiece, clearLoadDataPiece, getClearPermisionLoadData, getClearPermisionLoadDataPiece, setRequiredPlacesErrors } from "../../../../features/addLoad/addLoadSlice"
import { showModal } from "../../../../features/modal/modalSlice"
import { useEffect } from "react"
import { useMemo } from "react"

const Container = styled.div`
    width: calc(100% - 540px);

    .wrapper{
        width: 100%;
        display: flex;
        flex-direction: column;
        color: ${({theme}) => theme.mainTextColor};

        .top-container{
            width: 100%;
            display: flex;
            justify-content: space-between;
            margin-bottom: 20px;

            h3{
                font-size: var(--font-size-lg);
                font-weight: var(--font-weight-xl);
            }

            .icon-wrapper{
                display: flex;
                align-items: center;
                gap: 10px;

                .clear-data-piece-btn{
                    font-size: var(--font-size-sm);
                    font-weight: var(--font-weight-lg);
                    text-decoration: underline;
                }

                .sett-icon{
                    font-size: 2rem;
                }
            }
        }

        .group{
            margin: 20px 0;
            padding-left: 40px;
        }

        .menu-section-container{
            width: 100%;
            margin:  20px 60px;
            display: flex;
            justify-content: center;
        }
    }
`

const menuList = [
    {
        id:1,
        name:"Yükleme",
    },
    {
        id:2,
        name:"Boşaltma",
    },
    {
        id:3,
        name:"Rota Planlama",
    },
    {
        id:4,
        name:"Yük",
    },
    {
        id:5,
        name:"Araç",
    },
  
    {
        id:6,
        name:"Ödeme",
    },
  ]

const InputSide = ({kayitGuncelle}) => {

    // const {phase} = useSelector(state => state.addLoad)
    const dispatch = useDispatch()
    const {route} = useSelector(state => state.updateLoad)
    const [phase, setPhase] = useState({
        id: 1,
        name:"Yükleme"
    })

  return (
    <Container>
        <div className="wrapper">

            <div className="top-container">
                <h3>Taşıma Talebi Güncelle</h3>

                <div className="icon-wrapper">
                    {/* {
                        phase.id !== 3 &&
                        <button className="clear-data-piece-btn" onClick={() => {dispatch(getClearPermisionLoadDataPiece(phase)); dispatch(showModal("clearPermisionLoadDataPiece"))}}>{phase.name} Aşaması Verilerini Temizle</button>
                    } */}
                    <IoSettingsSharp onClick={() => dispatch(setRequiredPlacesErrors(true))}/>
                </div>
            </div>

            <div className="menu-section-container">
                <MenuSection phase={phase} setPhase={setPhase} menuList={menuList}/>
            </div>

            <div className="section-container">
                {
                    phase.id === 1 &&
                    <YuklemeSection kayitGuncelle={kayitGuncelle} setPhase={setPhase} yuklemeDataList={  route.filter(item => item.locationType === "yukleme")}/>
                }

                {
                    phase.id === 2 &&
                    <BosaltmaSection kayitGuncelle={kayitGuncelle} setPhase={setPhase} bosaltmaDataList={route.filter(item => item.locationType === "bosaltma")}/>
                }

                {
                    phase.id === 3 &&
                    <RoutePlanlamaSection setPhase={setPhase}/>
                }

                {
                    phase.id === 4 &&
                    <LoadSection setPhase={setPhase}/>
                }

                {
                    phase.id === 5 &&
                    <AracSection setPhase={setPhase}/>
                }

                {
                    phase.id === 6 &&
                    <OdemeSection setPhase={setPhase}/>
                }

            </div>

        </div>
    </Container>
  )
}

export default InputSide